import { observer } from 'mobx-react-lite';
import { FC, useCallback } from 'react';

import { GroupsPlaceholder } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';

import { List } from 'APP/components/List/List';
import { User } from 'STORE/Users/User/User';

import { ISelectContactsPresenter, IExtendedUsersPresenter } from '../../SelectContacts.types';
import { UserWithCheckbox } from '../UserWithCheckbox/UserWithCheckbox';
import styles from './ExtendedUsers.styles.m.css';

interface IExtendedUsersProps {
  presenter: IExtendedUsersPresenter;
  selectContactsPresenter: ISelectContactsPresenter;
}

export const ExtendedUsers: FC<IExtendedUsersProps> = observer(
  ({ presenter, selectContactsPresenter }) => {
    const { t } = useTranslation();

    const renderItem = useCallback((contact: User) => {
      return (
        <UserWithCheckbox
          user={contact}
          toggleUser={selectContactsPresenter.toggleContact}
          getIsSelected={selectContactsPresenter.getIsSelected}
        />
      );
    }, []);

    const props = {
      className: styles.list,
      isLoading: presenter.isLoading,
      isScrollable: false,
      data: presenter.users,
      keyExtractor: (user: User) => user.id,
      hasMore: presenter.hasMore,
      onEndReached: presenter.loadMore,
      renderItem,
      SpinnerComponent: (
        <GroupsPlaceholder
          count={presenter.users.length > 0 ? 2 : 10}
          className={styles.placeholders}
        />
      ),
    };

    return (
      <>
        <div className={styles.morePeople}>{t('extended_search_title')}</div>
        <List {...props} />
      </>
    );
  }
);
